import { createFileRoute } from '@tanstack/react-router';
import { autoManagedStaticData } from '../auto-managed';

export const Route = createFileRoute('/_private-routes/auto-managed/')({
  staticData: autoManagedStaticData
});
